<div class="custom-product-card">
  <div class="custom-card-header">
    <section>
      <a *ngIf="productInfo?.images; else noImage" (click)="itemSelected(productInfo)">
        <cx-media class="cx-product-image" [container]="productInfo.images?.PRIMARY" format="product" [alt]="productInfo.summary">
        </cx-media>
      </a>

      <ng-template #noImage>
        <a (click)="itemSelected(productInfo)">
          <img class="image-set-in-card product-img" [src]="fallbackImage" alt="" />
        </a>
      </ng-template>
    </section>

    <a class="c-linked-heading" (click)="itemSelected(productInfo)">
      <h3 class="c-heading c-heading-h3 my-2">{{ productInfo.name }}</h3>
    </a>
  </div>

  <section class="custom-card-body" *ngIf="!iconDisplay">
    <p
      class="custom-tab-p display-type text-fixed-medium"
      [innerHTML]="sanitizer.bypassSecurityTrustHtml(description | slice : 0 : 300)">
    </p>

    <a class="show-more display-type" *ngIf="description?.length > 300" [routerLink]="['/product', productInfo.code, productInfo.code]">
      ...Show More
    </a>
  </section>

  <section class="custom-card-body" *ngIf="iconDisplay">
    <section class="info-tabs">
      <app-my-tabs>
        <app-my-tab *ngIf="productInfo?.batchInfo?.batchNumber" tabIcon="icn-batchexpiry.svg">
          <div class="py-4">
            <p class="custom-tab-title">{{ 'plp.batchNumber' | cxTranslate }}</p>
            <p class="batchinfo-p">{{ productInfo?.batchInfo?.batchNumber }}</p>
            <p class="custom-tab-title">{{ 'plp.expiryDate' | cxTranslate }}</p>
            <p class="batchinfo-p mb-0">{{ productInfo?.batchInfo?.expiryDate }}</p>
          </div>
        </app-my-tab>
        <app-my-tab tabIcon="information.svg" class="product-detail">
          <div class="pt-4 mb-4 mb-md-0 details-text">
            <p class="custom-tab-title">{{ 'plp.details' | cxTranslate }}</p>
            <div
              class="custom-tab-p display-type text-fixed-medium text"
              *ngIf="description != null"
              [innerHTML]="sanitizer.bypassSecurityTrustHtml(description | slice : 0 : 50)"
            ></div>
            <a
              class="c-link"
              *ngIf="description?.length > 50"
              [routerLink]="['/product', productInfo.code, productInfo.code]">
              {{ 'plp.showMore' | cxTranslate }}
            </a>
          </div>
        </app-my-tab>

        <app-my-tab *ngIf="productInfo?.volumePrices?.length > 0 && userDetails !== undefined" tabIcon="price-master.svg">
          <div class="padding-0">
            <section class="prodtabs-cont prod-promotab active">
              <p class="custom-tab-title">
                {{ 'plp.volumeDiscounts' | cxTranslate }}
              </p>
              <section class="discount-list">
                <table aria-describedby="cartTable" class="c-table c-table--branded">
                  <th></th>
                  <tbody>
                    <tr *ngFor="let prices of productInfo?.volumePrices; let i = index">
                      <td>
                        {{ prices?.minQuantity }} - {{ prices?.maxQuantity }}
                        {{ 'plp.units' | cxTranslate }}:
                      </td>

                      <td>
                        {{ prices?.value | localCurrency }}
                        <span *ngIf="i > 0" class="text-success text-fixed-legal text-uppercase">
                          {{ 'plp.volumePricesSave' | cxTranslate }}
                        </span>
                        <br *ngIf="i > 0" />
                        <span class="font-bold">
                          {{productInfo?.volumePrices[0].value - productInfo?.volumePrices[i].value | localCurrency }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </section>
          </div>
        </app-my-tab>

        <app-my-tab *ngIf="monographLink" tabIcon="excel-sample.svg">
          <div class="padding-0">
            <p class="custom-tab-title">{{ 'plp.monograph' | cxTranslate }}</p>
            <p class="custom-tab-p">
              <img class="pdf-icon" src="icons/pdf.svg" alt="" />
              &nbsp;<a alt="" [href]="monographLink" target="_blank" class="c-link">
                {{ 'plp.monograph' | cxTranslate }}
              </a>
            </p>
          </div>
        </app-my-tab>

        <app-my-tab *ngIf="productInfo?.productUpdates" tabIcon="warning.svg">
          <div class="padding-0">
            <p class="custom-tab-title">{{ 'plp.productUpdate' | cxTranslate }}</p>
            <p class="custom-tab-p productupdate-p text-fixed-medium">
              {{ productInfo?.productUpdates | slice : 0 : 300 }}
            </p>
            <a
              class="show-more display-type"
              *ngIf="productInfo?.productUpdates?.length > 300"
              [routerLink]="['/product', productInfo.code, productInfo.code]">
              ...Show More
            </a>
          </div>
        </app-my-tab>
      </app-my-tabs>
    </section>
  </section>

  <div class="custom-card-footer">
    <p class="text-fixed-legal-copy u-border-bottom-grey mb-1">
      <span class="font-bold">{{ 'plp.productNumber' | cxTranslate }}</span>
      : {{ productInfo?.sapEan }}
    </p>
    <app-contracts-partial
      [contractFromCartApi]="contractFromCartApi"
      [conditions]="productInfo?.conditions"
      [selectedChannel]="channelSelected"
      [hasMatchingContract]="hasMatchingContract"
      [showPriceGroup]="showPriceGroup"
      [priceGroupToShow]="priceGroupToShow"
      (selectedContract)="onSelectedContract($event)"
      (selectPriceGroup)="onSelectPriceGroup($event)"
    />

    <div *ngIf="userDetails !== undefined">
      <div>
        <div *ngIf="!productInfo.flu">
          <h4 class="my-1 d-block" *ngIf="productInfo?.actualPotency">
            {{ 'plp.actualPotency' | cxTranslate }}:
            <span class="font-bold"> {{ productInfo?.actualPotency }}</span>
          </h4>
          <div class="justify-content-sm-around" *ngIf="productInfo?.actualPotency">
            <h4 class="d-block">
              {{ 'plp.iuPrice' | cxTranslate }}:
              <span *ngIf="productInfo?.iuPrice === undefined || productInfo?.iuPrice?.value === undefined">-</span>
              <span class="font-bold" *ngIf="productInfo?.iuPrice && productInfo?.iuPrice?.value !== undefined">
                {{ productInfo?.iuPrice?.value | localCurrency }}
              </span>
            </h4>
          </div>
          <div
            class="d-flex justify-content-around flex-wrap-reverse mt-4 mb-3">
            <div class="mb-2">
              <h4 class="d-block" *ngIf="productInfo?.actualPotency; else notActualPotency">
                {{ 'plp.unitPrice' | cxTranslate }}
              </h4>
              <ng-template #notActualPotency>
                <h4 class="d-block">
                  {{ 'plp.yourPrice' | cxTranslate }}
                  <br *ngIf="channelSelected === PriceChannel.PUBLIC" />
                  {{ ProductUtils.getUnitTranslation(channelSelected) }}
                </h4>
              </ng-template>
              <!-- Prices -->
              <span class="c-heading c-heading-h3">
                <!-- Price Private-->
                <span *ngIf="productInfo?.price == undefined || productInfo?.price?.value === undefined">-</span>
                <span
                  *ngIf="
                    productInfo?.price &&
                    productInfo?.price?.value !== undefined &&
                    (channelSelected === PriceChannel.PRIVATE ||
                      (channelSelected === PriceChannel.PUBLIC && !productInfo?.conditions))
                  ">
                  {{ productInfo?.price?.value | localCurrency }}
                </span>
                <!-- Dynamic price Public Channel -->
                <span
                  id="prod-price-{{ productInfo?.code }}"
                  *ngIf="channelSelected === PriceChannel.PUBLIC && productInfo?.conditions && productInfo?.conditions.length >= 1">
                  <ng-container *ngFor="let condition of productInfo?.conditions">
                    <ng-container *ngIf="condition?.contractId == contractSelectedId && priceToShow">
                      {{ priceToShow | localCurrency }}
                    </ng-container>
                  </ng-container>
                </span>
              </span>
            </div>
            <!-- Units -->
            <div class="units wrap-text mb-3" *ngIf="!productInfo?.discontinued && productInfo?.available">
              <label for="{{ 'prodQuantity' + productInfo.code }}" class="mb-2 text-center font-weight-bold">
                {{ 'plp.units' | cxTranslate }}
                <br *ngIf="channelSelected === PriceChannel.PUBLIC" />
                {{ ProductUtils.getUnitTranslation(channelSelected) }}
              </label>
              <div class="unit-area d-flex flex-nowrap align-items-center justify-content-center">
                <span id="{{ 'unitMinus' + productInfo?.code }}" class="d-none"></span>
                <span id="{{ 'unitMinusDisable' + productInfo?.code }}" class="d-none"></span>
                <span id="{{ 'unitPlus' + productInfo?.code }}" class="d-none"></span>
                <span id="{{ 'unitPlusDisable' + productInfo?.code }}" class="d-none"></span>
                <button
                  id="{{ 'minusIcon' + productInfo.code }}"
                  class="c-count-change-btn disabled"
                  (click)="performQuantityComputation(2)">
                  <em class="fa fa-minus" aria-hidden="true"></em>
                </button>
                <input
                  type="number"
                  [class]="{
                    'custom-product-card__quantityPublic': channelSelected === PriceChannel.PUBLIC,
                    'custom-product-card__quantityPrivate': channelSelected === PriceChannel.PRIVATE
                  }"
                  autoSizeInput
                  [includeBorders]="true"
                  class="prod-quantity text-center"
                  value="{{ conditionsForCartonsLogicMeet ? productInfo.numberOfUnitsPerCarton : '1' }}"
                  maxlength="4"
                  min="1"
                  max="{{ProductUtils.getMaximumQuantity(channelSelected)}}"
                  (blur)="performQuantityComputation(null)"
                  id="{{ 'prodQuantity' + productInfo.code }}" />
                <button
                  id="{{ 'plusIcon' + productInfo.code }}"
                  class="c-count-change-btn"
                  (click)="performQuantityComputation(1)">
                  <em class="fa fa-plus" aria-hidden="true"></em>
                </button>
              </div>
              <div *ngIf="conditionsForCartonsLogicMeet" class="w-100 mt-1" id="{{'noOfCartons' + productInfo?.code}}">
                <span class="red">min 1 cx embarque</span>
              </div>
            </div>
          </div>
        </div>
        <app-add-to-cart-button
          [productInfo]="productInfo"
          [selectedChannel]="channelSelected"
          [userDetails]="userDetails"
          [contractSelected]="contractSelected"
          [priceToShowGroupId]="priceToShowGroupId"
          [contractSelectedId]="contractSelectedId"
          [carts]="cartItems"
          [enableBtn]="enableBtn"
        />
      </div>
    </div>
  </div>
</div>
